// UnloadWarningContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";

type UnloadWarningContextType = {
  setShouldWarn: (shouldWarn: boolean) => void;
};

const UnloadWarningContext = createContext<UnloadWarningContextType>({
  setShouldWarn: () => {},
});

export const UnloadWarningProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [shouldWarn, setShouldWarn] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldWarn) {
        e.preventDefault();
        e.returnValue = ""; // Required for most browsers
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldWarn]);

  return (
    <UnloadWarningContext.Provider value={{ setShouldWarn }}>
      {children}
    </UnloadWarningContext.Provider>
  );
};

// Custom hook
export const useUnloadWarning = () => useContext(UnloadWarningContext);
